import semver from 'semver';

export const hasAnUpdateAvailable = (latestVersion, currentVersion) => {
  if (!semver.valid(latestVersion)) {
    return false;
  }
  return semver.lt(currentVersion, latestVersion);
};

// O aviso compara a versão do fork com a do Chatwoot público e pede para
// atualizar a instância. Só quem opera a instalação (super admin) pode fazer
// isso; para o administrador da conta do cliente o recado não faz sentido.
export const canSeeInstanceUpdate = user => user?.type === 'SuperAdmin';
